export type ArticleBlock =
  | { type: "p"; text: string }
  | { type: "h"; text: string }
  | { type: "quote"; text: string };

export type Article = {
  id: string;
  title: string;
  excerpt: string;
  category: string;
  categoryName: string;
  author: string;
  date: string;
  readTime: number;
  views: string;
  comments: number;
  tags: string[];
  cover: string;
  hot: number;
  badge?: string;
  body: ArticleBlock[];
};

export const articles: Article[] = [
  {
    id: "shen-mubai-night",
    title: "深夜行程被拍后续：当事人工作室发布情况说明",
    excerpt:
      "持续三天的讨论终于有了正面回应。工作室说明还原了当晚时间线，也对网络流传的部分截图做了澄清。",
    category: "downfall",
    categoryName: "明星塌房",
    author: "编辑组 · 林一",
    date: "2026-09-11",
    readTime: 6,
    views: "128.6w",
    comments: 3421,
    tags: ["塌房", "情况说明", "时间线"],
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20evening%20city%20skyline%20with%20warm%20street%20lights%2C%20moody%20amber%20and%20deep%20red%20tones%2C%20cinematic%20night%20atmosphere%2C%20abstract%20editorial%20photography%2C%20soft%20grain%20and%20high%20contrast&width=1200&height=800&seq=baoliao-cover-a1&orientation=landscape",
    hot: 98,
    badge: "热点",
    body: [
      { type: "p", text: "围绕顶流男演员沈慕白深夜行程的讨论，从一张模糊的路透照开始，在三天内冲上了多个平台的热搜。昨晚，其工作室通过官方账号发布了一份情况说明，给出了当晚的完整时间线。" },
      { type: "h", text: "事件回顾" },
      { type: "p", text: "9 月 8 日晚，有网友在社交平台发布了一组拍摄于市中心的照片，并配文称「行程与公开安排不符」。由于拍摄角度较远，画面中人物身份一度存在争议，相关话题在当晚迅速发酵。" },
      { type: "p", text: "次日上午，多个账号开始转载经过二次加工的截图，其中部分画面出现了明显的拼接痕迹。编辑组比对原始发布记录后发现，至少有两张流传较广的图片并非同一时间拍摄。" },
      { type: "h", text: "工作室说明的关键内容" },
      { type: "p", text: "情况说明中，工作室列出了三个时间节点：当晚 20:40 结束拍摄、21:30 与团队聚餐、23:10 返回住处。说明同时指出，网络流传的「另一场聚会」照片实为三年前的旧图。" },
      { type: "quote", text: "对于不实信息的传播，我们已委托律师进行证据保全，同时也希望大家在完整信息出来之前，给当事人留出基本的空间。" },
      { type: "p", text: "值得注意的是，说明并未回应关于商务活动安排的传闻，这一部分仍然是讨论的焦点。" },
      { type: "h", text: "目前进展" },
      { type: "p", text: "截至发稿，最初发布照片的账号已删除相关内容，并在简介中表示「信息有误」。相关话题的热度从峰值有所回落，但衍生讨论仍在继续。编辑组会持续跟进，并在有明确进展时更新本篇内容。" },
    ],
  },
  {
    id: "lin-zhixia-album",
    title: "人气女歌手林知夏先行曲登顶：数据背后的收听结构",
    excerpt:
      "新专辑先行曲上线两小时登顶热歌榜。除了粉丝打榜，普通听众的增长曲线同样值得关注。",
    category: "insider",
    categoryName: "娱乐圈内幕",
    author: "编辑组 · 周舟",
    date: "2026-09-10",
    readTime: 5,
    views: "76.2w",
    comments: 1180,
    tags: ["音乐作品", "热歌榜", "数据观察"],
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20sound%20wave%20visualization%20in%20warm%20gold%20and%20crimson%20gradient%2C%20glowing%20audio%20bars%20on%20dark%20stage%20backdrop%2C%20artistic%20music%20editorial%20concept%2C%20clean%20modern%20composition&width=1200&height=800&seq=baoliao-cover-a2&orientation=landscape",
    hot: 91,
    body: [
      { type: "p", text: "林知夏的新专辑先行曲《晚风快递》在上线两小时后登顶多个平台的热歌榜。这首歌也是她近两年第一次以完整创作人身份参与的作品。" },
      { type: "h", text: "成绩单" },
      { type: "p", text: "上线 24 小时，歌曲在主要音乐平台的新歌榜保持第一，收藏量突破百万。与以往不同的是，这次的非粉丝听众占比明显更高，出现在了多个城市电台的点播列表中。" },
      { type: "h", text: "为什么会被听见" },
      { type: "p", text: "从制作上看，这首歌弱化了强节奏副歌，选择了更接近民谣的编曲，人声位置靠前。乐评人普遍认为，这种处理让它在通勤场景中更容易被完整听完，而完整播放率的提升又会进一步影响平台的推荐权重。" },
      { type: "quote", text: "它不急着在十五秒里抓住你，而是让你慢慢听进去，这在当下的流行制作里其实挺难得的。" },
      { type: "h", text: "后续安排" },
      { type: "p", text: "据官方公布的信息，专辑完整版将于本月底上线，在此之前还会释出第二支先行曲。巡演场次正在筹备中。" },
    ],
  },
  {
    id: "variety-editing",
    title: "综艺录制花絮流出，剪辑顺序引发现场观众讨论",
    excerpt:
      "一段现场观众拍下的录制花絮在网上流传，与正片播出顺序存在差异，节目组暂未回应。",
    category: "variety",
    categoryName: "综艺瓜田",
    author: "编辑组 · 何夕",
    date: "2026-09-09",
    readTime: 4,
    views: "54.8w",
    comments: 962,
    tags: ["综艺", "剪辑", "现场"],
    cover:
      "https://readdy.ai/api/search-image?query=empty%20television%20studio%20stage%20with%20warm%20amber%20spotlights%20and%20dark%20background%2C%20stylized%20minimal%20production%20design%2C%20atmospheric%20editorial%20photography%20with%20soft%20glow&width=1200&height=800&seq=baoliao-cover-a3&orientation=landscape",
    hot: 78,
    body: [
      { type: "p", text: "某竞技类综艺最新一期播出后，一段由现场观众拍摄的录制花絮在社交平台流传。花絮中的投票环节顺序，与正片呈现的顺序并不完全一致。" },
      { type: "h", text: "差异出现在哪里" },
      { type: "p", text: "花絮显示，嘉宾的第一轮表演在当晚录制时靠后，而正片中这一轮被剪到了开场位置。节目组尚未就此作出说明。" },
      { type: "p", text: "有熟悉综艺制作流程的从业者表示，调整段落顺序是常见的后期手法，用于优化叙事节奏，并不一定意味着结果被改动。" },
      { type: "h", text: "讨论的另一面" },
      { type: "p", text: "也有观众认为，如果顺序调整会影响观众对嘉宾表现的评价，那就应该在片尾加上说明。目前相关话题的讨论更多集中在「综艺是否需要更透明的剪辑提示」上。" },
    ],
  },
  {
    id: "gu-yan-old-interview",
    title: "旧访谈被重新翻出，顾衍早期言论引发新一轮讨论",
    excerpt:
      "一段拍摄于八年前的访谈片段重新流传，其中的表述与如今的作品态度形成对比，引发讨论。",
    category: "history",
    categoryName: "艺人黑历史",
    author: "编辑组 · 沈知",
    date: "2026-09-08",
    readTime: 5,
    views: "61.3w",
    comments: 1508,
    tags: ["旧访谈", "言论", "回看"],
    cover:
      "https://readdy.ai/api/search-image?query=old%20stacked%20newspapers%20and%20magazines%20on%20a%20wooden%20desk%20with%20warm%20sepia%20lighting%2C%20vintage%20editorial%20still%20life%2C%20dust%20particles%20in%20soft%20sunlight%2C%20muted%20brown%20palette&width=1200&height=800&seq=baoliao-cover-a4&orientation=landscape",
    hot: 72,
    body: [
      { type: "p", text: "演员顾衍八年前的一段访谈视频，在本周被重新剪辑并传播。视频中他对「表演方法」的一些表述，与近年他在公开场合的态度形成了明显对比。" },
      { type: "h", text: "当时的语境" },
      { type: "p", text: "需要说明的是，这段访谈拍摄于他刚入行的第二年，当时的提问方向本身就带有调侃性质。单独截取其中一句，容易脱离原本的对话环境。" },
      { type: "h", text: "他后来怎么说的" },
      { type: "p", text: "在去年的一个行业论坛上，顾衍曾主动提到自己早年的表达过于绝对，并表示「人是会变的，作品会留下痕迹」。这段话也被网友重新翻出，作为对照。" },
      { type: "quote", text: "把八年前的一句话当成今天的证据，这对谁都不太公平。" },
      { type: "p", text: "目前讨论已经逐渐从「言论对错」转向「如何对待艺人的成长过程」，编辑组认为这是一个更值得聊下去的方向。" },
    ],
  },
  {
    id: "su-wanqing-contract",
    title: "苏晚晴解约风波进展：双方就作品版权达成初步共识",
    excerpt:
      "持续近两个月的解约争议有了阶段性的结果，双方就已完成作品的版权归属给出了说明。",
    category: "downfall",
    categoryName: "明星塌房",
    author: "编辑组 · 林一",
    date: "2026-09-07",
    readTime: 6,
    views: "89.5w",
    comments: 2210,
    tags: ["解约", "版权", "进展"],
    cover:
      "https://readdy.ai/api/search-image?query=folded%20legal%20documents%20and%20a%20fountain%20pen%20on%20a%20warm%20wooden%20table%2C%20soft%20amber%20desk%20lighting%2C%20minimal%20editorial%20still%20life%2C%20shallow%20depth%20of%20field%2C%20muted%20tones&width=1200&height=800&seq=baoliao-cover-a5&orientation=landscape",
    hot: 85,
    body: [
      { type: "p", text: "演员苏晚晴与经纪公司的解约争议，从七月初持续至今。双方在上周进行了一次面对面的沟通，就已完成作品的版权归属达成了初步共识。" },
      { type: "h", text: "争议的起点" },
      { type: "p", text: "分歧最初出现在续约条款上。艺人方认为部分条款对创作自主权限制过多，公司方则表示合同内容符合行业惯例。相关讨论一度延伸到作品宣传期的投入分配。" },
      { type: "h", text: "目前的结果" },
      { type: "p", text: "根据双方共同发布的说明，已完成的影视作品将继续按原计划上线，署名与分成比例不变；尚未开拍的项目则由双方另行协商。说明中没有提及解约是否已经正式完成。" },
      { type: "quote", text: "把内容做好，是对观众最基本的交代。其余的问题，会按照约定的方式解决。" },
      { type: "p", text: "业内人士普遍认为，这一进展意味着最激烈的阶段已经过去，但后续细节仍需观察。" },
    ],
  },
  {
    id: "lu-shiyan-data",
    title: "陆时宴作品讨论度与播放量不匹配，数据口径成话题",
    excerpt:
      "剧集播放量不低，讨论热度却集中在配角身上。围绕「数据好看但没出圈」的讨论再次出现。",
    category: "insider",
    categoryName: "娱乐圈内幕",
    author: "编辑组 · 周舟",
    date: "2026-09-06",
    readTime: 5,
    views: "43.1w",
    comments: 786,
    tags: ["剧集", "数据", "讨论度"],
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20bar%20chart%20and%20trend%20line%20visualization%20in%20crimson%20and%20gold%20on%20warm%20cream%20paper%20background%2C%20minimal%20data%20editorial%20concept%2C%20clean%20geometric%20shapes%2C%20soft%20shadow&width=1200&height=800&seq=baoliao-cover-a6&orientation=landscape",
    hot: 68,
    body: [
      { type: "p", text: "由陆时宴主演的都市剧在上周收官，平台公布的正片播放量处于同期前列。但在社交平台的话题讨论中，热度最高的角色却是剧中的配角。" },
      { type: "h", text: "两种热度" },
      { type: "p", text: "播放量反映的是观看行为，讨论度反映的是表达意愿。当两者出现明显落差时，通常意味着内容被「看完」但没被「记住」。" },
      { type: "p", text: "从评论抽样来看，观众对角色的讨论集中在人物动机上，而主角的成长线被认为推进得过于平缓。" },
      { type: "h", text: "值得关注的信号" },
      { type: "p", text: "有平台运营人员透露，如今的统计口径会更看重完播率和二次传播，单一的播放数字参考价值正在下降。对于演员来说，角色是否被记住，可能比榜单位置更重要。" },
    ],
  },
  {
    id: "jiang-yutong-return",
    title: "沉寂两年后回归，江语桐新剧发布会现场状态引发关注",
    excerpt:
      "两年没有新作品的江语桐出现在新剧发布会上，谈到这段时间的选择。",
    category: "romance",
    categoryName: "恋情风云",
    author: "编辑组 · 何夕",
    date: "2026-09-05",
    readTime: 4,
    views: "38.7w",
    comments: 654,
    tags: ["回归", "发布会", "新剧"],
    cover:
      "https://readdy.ai/api/search-image?query=elegant%20empty%20press%20conference%20stage%20with%20warm%20amber%20lighting%20and%20crimson%20drapes%2C%20stylized%20editorial%20atmosphere%2C%20soft%20focus%20background%20with%20cinematic%20tones&width=1200&height=800&seq=baoliao-cover-a7&orientation=landscape",
    hot: 61,
    body: [
      { type: "p", text: "两年没有新作品上线的江语桐，本周出现在新剧《深巷有光》的发布会上。她在现场表示，这段时间主要是「把生活过明白了」。" },
      { type: "h", text: "关于这两年的空白" },
      { type: "p", text: "她提到，期间推掉了几部同类型的剧本，转而花时间学习了一门与表演无关的技能。她说：「我不想让自己一直在舒适区里重复。」" },
      { type: "h", text: "新剧看点" },
      { type: "p", text: "《深巷有光》是一部现实题材的作品，她在其中饰演一位社区工作者。从目前释出的片花来看，角色与以往的形象有较大区别。" },
      { type: "p", text: "关于网络上对其感情状态的猜测，她没有直接回应，只表示「现在的重心在作品上」。" },
    ],
  },
  {
    id: "wen-zimo-endorsement",
    title: "温子墨拿下高奢代言，商务资源的评估标准正在变化",
    excerpt:
      "品牌签约看的不再只是流量。从温子墨的案例聊聊商务合作评估逻辑的变化。",
    category: "insider",
    categoryName: "娱乐圈内幕",
    author: "编辑组 · 沈知",
    date: "2026-09-04",
    readTime: 5,
    views: "35.9w",
    comments: 512,
    tags: ["商务", "代言", "品牌"],
    cover:
      "https://readdy.ai/api/search-image?query=luxury%20boutique%20interior%20with%20warm%20gold%20and%20cream%20tones%2C%20elegant%20display%20pedestals%20and%20soft%20spotlights%2C%20minimal%20premium%20editorial%20photography%2C%20refined%20composition&width=1200&height=800&seq=baoliao-cover-a8&orientation=landscape",
    hot: 56,
    body: [
      { type: "p", text: "温子墨成为某国际品牌在大中华区的代言人，这一消息在商务圈内的讨论度，甚至超过了娱乐话题本身。" },
      { type: "h", text: "为什么是他" },
      { type: "p", text: "从公开数据看，温子墨的粉丝规模并非同年龄段里最大的，但他的内容口碑与负面舆情比例长期保持在较低水平。品牌方在沟通中多次提到「稳定性」。" },
      { type: "h", text: "评估逻辑的变化" },
      { type: "p", text: "多位商务从业者表示，近两年品牌更看重艺人的长期形象风险，而不是短期的爆发式流量。合作的周期被拉长，考核维度也从单次曝光转向持续的内容共创。" },
      { type: "quote", text: "签一个人，签的是他未来两年不会带来麻烦，以及能不能一起把故事讲好。" },
      { type: "p", text: "这一变化对艺人和团队提出了新的要求：作品质量、公众表达与商务选择之间，需要更一致的判断。" },
    ],
  },
  {
    id: "music-festival-lineup",
    title: "秋季音乐节阵容官宣：票价与场次安排成了讨论重点",
    excerpt:
      "阵容公布当天，讨论最热烈的不是艺人名单，而是分日票价和场地容量。",
    category: "variety",
    categoryName: "综艺瓜田",
    author: "编辑组 · 林一",
    date: "2026-09-03",
    readTime: 4,
    views: "29.4w",
    comments: 438,
    tags: ["音乐节", "阵容", "票价"],
    cover:
      "https://readdy.ai/api/search-image?query=outdoor%20music%20festival%20crowd%20silhouettes%20against%20warm%20sunset%20sky%2C%20distant%20stage%20lights%20glowing%20amber%2C%20stylized%20atmospheric%20editorial%20photography%2C%20warm%20red%20and%20gold%20palette&width=1200&height=800&seq=baoliao-cover-a9&orientation=landscape",
    hot: 52,
    body: [
      { type: "p", text: "今年秋季的第一场大型音乐节在昨天公布了完整阵容。与前几年不同，今年的讨论焦点很快从艺人名单转移到了票价结构上。" },
      { type: "h", text: "票价是怎么定的" },
      { type: "p", text: "主办方采用了分日售票的方式，单日票与通票之间的价差较大。有观众计算后发现，如果只看其中一天的头部阵容，单日票的性价比并不高。" },
      { type: "h", text: "场地与体验" },
      { type: "p", text: "另一个被反复提到的问题是场地容量。去年的同场地曾出现入场排队时间过长的情况，主办方表示今年会增设入口并优化动线。" },
      { type: "p", text: "截至发稿，首日票已售罄，后续场次的售票安排将在本周内公布。" },
    ],
  },
];

export const getArticleById = (id: string) => articles.find((a) => a.id === id);
export const getArticlesByCategory = (slug: string) =>
  articles.filter((a) => a.category === slug);
export const getRelatedArticles = (article: Article, count = 3) =>
  articles.filter((a) => a.id !== article.id).slice(0, count);